import { render, staticRenderFns } from "./EditorNewDiscussionButton.vue?vue&type=template&id=636a9650&"
import script from "./EditorNewDiscussionButton.vue?vue&type=script&lang=js&"
export * from "./EditorNewDiscussionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditorNewDiscussionButton.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/gutters/EditorNewDiscussionButton.vue
// module id = 1647
// module chunks = 1